<template>
  <el-card v-loading="loading">
    <div slot="header" class="clearfix">
      <span type="danger">{{ title }}</span>
    </div>
    <el-row :gutter="20" class="step">
      <el-col :span="4" class="step-title">导入须知</el-col>
      <el-col :span="18">
        <p class="step-item">
          第一步：下载导入模板 <a :href="templateUrl" download class="href">点击下载</a>
        </p>
        <p class="step-item">
          第二步：预览导入内容，导入条目数量限制<span class="text-danger"
            >{{ limit }}</span
          >条
        </p>
        <p class="step-item">第三步：预览结果无误后再导入</p>
        <p class="step-item">
          预览时,异常数据<span class="text-danger">标红</span>,需修改后重新导入
        </p>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="step">
      <el-col :span="4" class="step-title">选择导入的文件</el-col>
      <el-col :span="18" style="display: flex">
        <el-input v-model="fileUrl" class="m-r"></el-input>
        <el-upload
          class="m-r"
          action="/file.api"
          accept=".xls, .xlsx"
          ref="upload"
          :on-success="handleSuccess"
          :on-error="handleUploadError"
          :file-list="fileList"
          :data="uploadData"
          :name="uploadName"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-button class="m-r" type="primary" @click="previewFile"
          >预览</el-button
        >
        <el-button type="primary" @click="clearPreview">清除预览</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="step">
      <el-col :span="4" class="step-title">预览结果信息</el-col>
      <el-col :span="18" v-if="previewList.length">
        <div v-if="isValid">
          <span type="success">预览结果无异常</span>
          <el-button
            :loading="importLoading"
            :disabled="loading || importLoading || previewList.length > limit"
            @click="importList"
            type="primary"
            style="margin-left: 10px"
            >导入</el-button
          >
        </div>
        <div v-else>
          <span class="text-danger">预览结果异常</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="step">
      <el-col :span="4" class="step-title">预览结果</el-col>
      <el-col :span="18"> </el-col>
    </el-row>
    <el-row v-show="previewList.length">
      <element-table
        :data="previewList"
        :columns="columns"
        :maxHeight="400"
      ></element-table>
    </el-row>
  </el-card>
</template>

<script>
import ElementTable from "@/components/ElementTable";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
export default {
  props: {
    loading: Boolean,
    importLoading: Boolean,
    limit: { type: Number, default: 200 },
    templateUrl: String,
    columns: Array,
    isValid: Boolean,
    previewList: Array,
    title: String,
  },
  data() {
    return {
      fileUrl: "",
      fileList: [],
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
    };
  },
  components: {
    ElementTable,
  },
  methods: {
    handleSuccess(res, file) {
      const state = res && res.stat && res.stat.stateList && res.stat.stateList[0];
      const path = res && res.content && res.content[0] && res.content[0][this.uploadName];
      if (!state || state.code !== 0 || res.stat.code !== 0 || typeof path !== "string" || !path) {
        this.handleUploadError({ message: (state && state.msg) || "上传失败，未返回文件地址" });
        return;
      }
      this.fileUrl = /^https?:\/\//i.test(path) ? path : CONST_VD_IMGPREFIX.prefixImgUrl + path;
      this.previewFile();
    },
    handleUploadError(error) {
      this.fileUrl = "";
      this.$emit("on-upload-error", error.message || "上传失败，请重试");
      this.$message.error(error.message || "上传失败，请重试");
    },
    previewFile() {
      this.$emit("on-preview", this.fileUrl);
    },
    importList() {
      if (this.loading || this.importLoading || !this.isValid || !this.previewList.length || this.previewList.length > this.limit) return;
      this.$emit("on-import", this.previewList);
    },
    clearPreview() {
      this.previewList.splice(0);
    },
  },
};
</script>

<style lang="scss">
.step {
  line-height: 1.5;
  .href {
    color: #3399ff;
    border-bottom: 1px solid #3399ff;
  }
  .text-danger {
    color: red;
  }
  & + .step {
    margin: 20px;
  }
  p.step-item {
    margin: 0;
  }
  .step-title {
    text-align: right;
  }
}
.m-r {
  margin-right: 10px;
}
</style>
